export default function getSundayBeforeTheMonth(month: number, year: number): Date {
  const firstDayOfTheMonth = new Date(year, month, 1)

  let sunday: string | Date = ''

  while (sunday === '') {
    if (firstDayOfTheMonth.getDay() === 0) {
      sunday = firstDayOfTheMonth
    } else {
      firstDayOfTheMonth.setDate(firstDayOfTheMonth.getDate() - 1)
    }
  }

  return sunday as Date
}
